module.exports = __webpack_public_path__ + "img/icon2.d0750904.png";